import { render } from "./Recruits.vue?vue&type=template&id=64f72ac1&ts=true"
import script from "./Recruits.vue?vue&type=script&lang=ts"
export * from "./Recruits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__